import { checklistComplementaryItems } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.ComplementaryItemsConstant';
import { ChecklistComplementItemResponse } from '@/core/domain/workorder/WorkOrdersChecklist/WorkOrdersChecklist.types';
import { Checkbox, Form, Input } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { FaCheck, FaExclamation, FaTimes } from 'react-icons/fa';

const labelStyle = {
  cursor: 'pointer',
  minWidth: 50,
  width: 50,
  padding: 0,
  margin: 0,
  display: 'inline-flex',
  flex: 1,
  justifyContent: 'center',
};

interface Props {
  handleAllCheckbox?: (
    checked: boolean,
    responseType: ChecklistComplementItemResponse,
  ) => void;

  handleAllSelected?: (
    responseType: ChecklistComplementItemResponse,
  ) => boolean;
  handleAllIndeterminate?: (
    responseType: ChecklistComplementItemResponse,
  ) => boolean;
  listName: string;
}

export default function complementItemsColumns({
  listName,
  handleAllCheckbox,
  handleAllSelected,
  handleAllIndeterminate,
}: Props): ColumnsType<typeof checklistComplementaryItems[0]> {
  const radioStyle = (response: string, value: string) => ({
    ...labelStyle,
    display: response === value ? 'none' : 'inline-flex',
  });

  const createResponseColumn = (
    responseType: ChecklistComplementItemResponse,
    label: string,
    icon: JSX.Element,
  ): ColumnsType<typeof checklistComplementaryItems[0]> => [
    {
      width: 200,
      title: (
        <Checkbox
          checked={!!handleAllSelected && handleAllSelected(responseType)}
          indeterminate={
            !!handleAllIndeterminate && handleAllIndeterminate(responseType)
          }
          onChange={({ target: { checked } }) => {
            if (handleAllCheckbox) handleAllCheckbox(checked, responseType);
          }}
          style={{ whiteSpace: 'nowrap', fontSize: 12 }}
        >
          {label}
        </Checkbox>
      ),
      render: (_, _row, index) => (
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue, setFieldValue }) => {
            const response = getFieldValue([listName, index, 'response']);

            const removeCheck = () =>
              setFieldValue([listName, index, 'response'], []);

            return (
              <Form.Item
                noStyle
                name={[index, 'response']}
                getValueFromEvent={(value: string[]) => {
                  const response = value.at(-1);
                  return response ? [response] : [];
                }}
              >
                <Checkbox.Group
                  style={{
                    justifyContent: 'space-around',
                    alignItems: 'center',
                    display: 'flex',
                    width: '100%',
                  }}
                >
                  {response && response[0] === responseType && (
                    <span onClick={removeCheck} style={labelStyle}>
                      {icon}
                    </span>
                  )}

                  <Checkbox
                    style={radioStyle(response && response[0], responseType)}
                    value={responseType}
                  />
                </Checkbox.Group>
              </Form.Item>
            );
          }}
        </Form.Item>
      ),
      align: 'center',
    },
  ];

  return [
    {
      dataIndex: 'label',
      title: 'Descrição',
      ellipsis: true,
      render: (label, row, index) => (
        <>
          <Form.Item
            hidden
            name={[index, 'description']}
            noStyle
            initialValue={row.value}
          >
            <Input />
          </Form.Item>
          {label}
        </>
      ),
    },
    ...createResponseColumn(
      ChecklistComplementItemResponse.Ok,
      'Ok',
      <FaCheck size={16} color="forestgreen" />,
    ),
    ...createResponseColumn(
      ChecklistComplementItemResponse.NotOk,
      'Não ok',
      <FaTimes size={16} color="red" />,
    ),
    ...createResponseColumn(
      ChecklistComplementItemResponse.Warning,
      'Atenção',
      <FaExclamation size={16} color="orange" />,
    ),
    {
      dataIndex: 'comment',
      title: 'Observação',
      width: 300,
      render: (_, _row, index) => (
        <Form.Item shouldUpdate noStyle>
          {({ getFieldValue }) => (
            <Form.Item noStyle name={[index, 'comment']}>
              <Input
                style={{ width: 300 }}
                disabled={!getFieldValue([listName, index, 'response'])}
              />
            </Form.Item>
          )}
        </Form.Item>
      ),
    },
  ];
}
